import React, { Component, Fragment } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Media from 'react-media';
import { CheckoutHeading } from './style';
import { CheckoutLayout as Layout } from '../../layout';
import { CheckoutHeader } from '../../header';
import Summary from '../../../containers/summary';
import OrderFormWizard from '../../../containers/wizard';
import Payment from '../../../containers/payment';

class Checkout extends Component {
  render() {
    const { match } = this.props;
    return (
      <Layout>
        <Fragment>
          <Layout.Left id="checkout-left-layout">
            <Layout.LeftHeader>
              <CheckoutHeader />
            </Layout.LeftHeader>
            <Layout.LeftBody id="checkout-left-layout-body">
              <Switch>
                <Route
                  exact
                  path={`${match.path}`}
                  render={() => {
                    return <Redirect to={`${match.path}/orderform`} />;
                  }}
                />
                <Route
                  exact
                  path={`${match.path}/orderform`}
                  render={() => {
                    return (
                      <Fragment>
                        <OrderFormWizard />
                      </Fragment>
                    );
                  }}
                />
                <Route
                  exact
                  path={`${match.path}/payorder`}
                  component={Payment}
                />
              </Switch>
            </Layout.LeftBody>
          </Layout.Left>
          <Layout.Right>
            <Layout.RightHeader>
              <CheckoutHeading>Zusammenfassung</CheckoutHeading>
            </Layout.RightHeader>
            <Summary />
          </Layout.Right>
        </Fragment>
      </Layout>
    );
  }
}

export default Checkout;



// WEBPACK FOOTER //
// ../shop_main/components/views/checkout/index.js